import { Outlet } from "react-router-dom";
import NavigationComponent from "../components/nav/NavigationComponent";
import styled from "styled-components";

const Main = styled.main`
    min-height: 100vh;
	margin-left: 80px;
	margin-bottom: 0px;
	padding: 24px 48px;

	@media (max-width: 480px) {
        min-height: calc(100vh - 80px);
		margin-left: 0px;
		margin-bottom: 80px;
		padding: 12px 24px;
	}
`;

export default function LayoutComponent() {
    return (
        <div>
            <header>
                <NavigationComponent />
            </header>
            <Main>
                <Outlet />
            </Main>
            <footer></footer>
        </div>
    );
}